import { DEEP_CONFIG, SINGLE_WALL } from '../constants';
/** Convert a string to number, return undefined if NaN */
const stringToNumber = (value) => {
    if (!value) {
        return value;
    }
    const converted = Number(value);
    if (isNaN(converted)) {
        return value;
    }
    return converted;
};
const mapSelectStateToNumbers = (selectState) => {
    return {
        door_type: selectState.door_type,
        size_width: stringToNumber(selectState.size_width?.value),
        size_depth: stringToNumber(selectState.size_depth?.value),
        size_height: stringToNumber(selectState.size_height?.value),
        size_width_left_85: stringToNumber(selectState.size_width_left_85?.value),
        size_width_right_85: stringToNumber(selectState.size_width_right_85?.value),
        size_width_left_88: stringToNumber(selectState.size_width_left_88?.value),
        size_width_right_88: stringToNumber(selectState.size_width_right_88?.value),
        size_depth_left: stringToNumber(selectState.size_depth_left?.value),
        size_depth_right: stringToNumber(selectState.size_depth_right?.value)
    };
};
/**
 * Get the basic insights payload from the survey, without any logic.
 *
 * @param formState The form state.
 * @returns A payload ready to send to insights.
 */
export const getSurveyPayload = (formState) => {
    const typedSelectState = mapSelectStateToNumbers(formState.selectState);
    const { door_type } = formState.selectState;
    const { storage_type, wall } = formState;
    const genericPayload = {
        door_type: door_type?.value,
        size_height: typedSelectState.size_height,
        storage_type
    };
    const singleWallPayload = {
        size_width: typedSelectState.size_width,
        size_depth: typedSelectState.size_depth
    };
    const leftWidth = typedSelectState.size_depth_right === Number(DEEP_CONFIG)
        ? typedSelectState.size_width_left_85
        : typedSelectState.size_width_left_88;
    const rightWidth = typedSelectState.size_depth_left === Number(DEEP_CONFIG)
        ? typedSelectState.size_width_right_85
        : typedSelectState.size_width_right_88;
    // Corner wall specific properties
    const cornerWallPayload = {
        size_width_left: leftWidth,
        size_width_right: rightWidth,
        size_depth_left: typedSelectState.size_depth_left,
        size_depth_right: typedSelectState.size_depth_right
    };
    const payloadObj = wall === SINGLE_WALL
        ? { ...genericPayload, ...singleWallPayload }
        : { ...genericPayload, ...cornerWallPayload };
    return payloadObj;
};
/**
 * Get a payload with a single survey option and its value.
 * @param id ID of the survey option
 * @param value The value
 * @param currentValue The current value of the option, used for storage_type
 * @returns Payload object ready to be sent to insights
 */
export const getSingleSurveyPayload = (id, value, currentValue) => {
    // If the survey option ID includes size, it should be treated as a number
    const parsedValue = id.includes('size') ? stringToNumber(value) : value;
    switch (id) {
        case 'size_width_left_85':
        case 'size_width_left_88':
            return { size_width_left: parsedValue };
        case 'size_width_right_85':
        case 'size_width_right_88':
            return { size_width_right: parsedValue };
        case 'storage_type': {
            const objType = {};
            if (currentValue?.includes(parsedValue)) {
                objType[id] = [];
            }
            else {
                objType[id] = [parsedValue];
            }
            return objType;
        }
        default: {
            const obj = {};
            obj[id] = parsedValue;
            return obj;
        }
    }
};
//# sourceMappingURL=getSurveyPayload.js.map